module.exports = __webpack_public_path__ + "static/mierb-book-1b6f63a92d95835e0f99da52fbf3f353.woff2";